/**
 * Created by XUQIANG on 2016/4/20.
 */
import React from 'react';
import ReactDOM from 'react-dom';
import { Modal } from 'antd';
import * as i18n from '../../i18n';

import PromptInfo from '../../utils/promptInfo.js';

const DialogType = PromptInfo.DialogType;
const DialogResult = PromptInfo.DialogResult;
const CHINESE = 'zh_CN';
const info_img = require('../../assets/gth.png');
const err_img = require('../../assets/X.png');
const warn_img = require('../../assets/i.png');
const success_img = require('../../assets/duihao.png');

class Dialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = { display: 're-show' };
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick = value => {
    this.setState({ display: 're-hidden' });
    if (!(typeof this.props.onClose == 'undefined')) {
      switch (value) {
        case 0:
          this.props.onClose(DialogResult.CANCEL);
          break;
        case 1:
          this.props.onClose(DialogResult.OK);
          break;
        default:
          this.props.onClose(DialogResult._NULL);
      }
    }
    //移除添加的div节点
    const { div } = this.props;
    ReactDOM.unmountComponentAtNode(div);
    div.parentNode.removeChild(div);
  };

  render() {
    let { locale, callback, cancelBack } = this.props;
    locale = locale || CHINESE;
    const messages = i18n[locale];

    let { type } = this.props;
    const { display } = this.state;
    let { title } = this.props;
    let style = 'fixed-message';
    let img_src = info_img;
    let btn = (
      <div>
        <a
          onClick={() => {
            this.handleClick(0);
            if (cancelBack) {
              cancelBack();
            }
          }}
        >
          {messages.dialog_btn_cancel}
        </a>
        <a
          onClick={() => {
            this.handleClick(1);
            if (callback) {
              callback();
            }
          }}
        >
          {messages.dialog_btn_ok}
        </a>
      </div>
    );
    switch (type) {
      case DialogType.INFORMATION:
        btn = (
          <a
            className="onlybtn"
            onClick={() => {
              this.handleClick(1);
              if (callback) {
                callback();
              }
            }}
          >
            {messages.dialog_btn_ok}
          </a>
        );
        title = title || messages.dialog_prompt_info;
        style = 'fixed-prompt';
        img_src = info_img;
        break;
      case DialogType.APP_ERROR:
        btn = (
          <a
            className="onlybtn"
            onClick={() => {
              this.handleClick(1);
              if (callback) {
                callback();
              }
            }}
          >
            {messages.dialog_btn_ok}
          </a>
        );
      case DialogType.ERROR:
        btn = (
          <a
            className="onlybtn"
            onClick={() => {
              this.handleClick(1);
              if (callback) {
                callback();
              }
            }}
          >
            {messages.error_info_new}
          </a>
        );
        title = title || messages.dialog_error_info;
        img_src = err_img;
        style = 'fixed-err';
        break;
      case DialogType.SUCCESS:
        title = title || messages.dialog_success_info;
        img_src = success_img;
        style = 'fixed-success';
        btn = (
          <a
            onClick={() => {
              this.handleClick(1);
              if (callback) {
                callback();
              }
            }}
          >
            {messages.dialog_btn_know}
          </a>
        );
        break;
      case DialogType.WARN:
        title = title || messages.dialog_warning_info;
        img_src = warn_img;
        style = 'fixed-warning';
        break;
    }

    return (
      <div className={`fixed-message ${display}`}>
        <div className="close-div" />
        <div className={style}>
          <div className="title-img">
            <img src={img_src} />
          </div>
          <p className="title" style={{ textAlign: 'center' }}>
            {title}
          </p>
          <p className="prompt-text">{this.props.message}</p>
          <div className="bott-btn">{btn}</div>
        </div>
      </div>
    );
  }
}

const openOldDailog = conf => {
  //添加一个节点供弹出框渲然
  if (document.getElementById('DialogDiv')) {
    return;
  }
  let div = document.createElement('div');
  div.id = 'DialogDiv';
  document.body.appendChild(div);
  ReactDOM.render(<Dialog {...conf} div={div} />, div);
};

const openNewDialog = conf => {
  const { type, message, locale, callback, onClose } = conf;
  const config = {
    content: message,
    onCancel: () => {
      onClose && onClose();
    },
    onOk: () => {
      callback && callback();
    }
  };
  switch (type) {
    case DialogType.SUCCESS:
      Modal.success(config);
      break;
    case DialogType.ERROR:
    case DialogType.APP_ERROR:
      Modal.error(config);
      break;
    case DialogType.INFORMATION:
      Modal.info(config);
      break;
    case DialogType.WARN:
    case DialogType.QUESTION:
      Modal.confirm(config);
      break;
    default:
      openOldDailog(conf);
  }
};
export default openNewDialog;



// WEBPACK FOOTER //
// ./src/components/commons/ReservationDialog.js